/**
 * Super Admin Module API - Super Admins
 * 
 * Database operations for fetching super admin users.
 * Uses core schema for profile data.
 */

import { supabase } from '@/integrations/supabase/client';
import type { SuperAdmin } from '../types';

// =============================================================================
// Queries
// =============================================================================

/**
 * Fetches all profiles marked as super admin.
 * Returns basic profile info (id, email, full_name, created_at).
 */
export async function fetchSuperAdmins(): Promise<SuperAdmin[]> {
  const { data, error } = await supabase
    .schema('core')
    .from('profiles')
    .select('id, email, full_name, created_at')
    .eq('is_super_admin', true)
    .order('email');

  if (error) throw error;
  return data as SuperAdmin[];
}
